<template>
  <div>
    <v-card-title class="headline">
      {{paymentDetailTitle()}}
    </v-card-title>

    <v-card-text
      v-if='form.paymentMethod === "insurance"'
      class='pt-3'
    >

      <p class='subtitle-1 font-weight-bold'> {{$t('As a courtesy, GSF will bill your insurance carrier on your behalf, but it is important to understand that you are ultimately responsible for the payment of your bill.')}} </p>

      <ul>
        <li class='subtitle-1 
    '>{{$t('You are required to provide us with the most correct and updated information about your insurance, and will be responsible for any charges incurred if the information provided is not correct or updated.')}} </li>
        <li class='subtitle-1 
    '>
          <a @click='insuraceDialog = true'>{{$t('Please note - GSF is unable to bill Medicare and Tricare for genetic counseling services. Please see our website to learn more about self pay options and our financial assistance program')}}
          </a>.
        </li>
        <li class='subtitle-1
    '>{{$t('Patients are responsible for the payment of co-pays, co-insurance, deductibles, and all other procedures or treatment not covered by their insurance plan.')}} </li>
        <li class='subtitle-1 
    '>{{$t('Patients may incur, and are responsible for the payment or any additional charges that are incurred in the process of collection of that payment.')}}</li>
        <li class='subtitle-1
    '>{{$t('Prior authorization may be required by your insurance for genetic counseling. It is your responsibility to know and understand the benefits and coverage of your insurance plan. If you would like to contact your insurance to find out if they cover genetic counseling services, they may ask for a procedure (or CPT) code for the visit. The code GSF bills for genetic counseling visits is 96040.')}}</li>
      </ul>

      <div class="mt-5">
        <v-row>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-select
              @change='stateCheck'
              :items="insuranceDropdown"
              v-model="form.insuraceType"
              :label="$t('Insurance Type')"
              :placeholder="$t('Insurance Type')"
              persistent-placeholder
              outlined
            ></v-select>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="form.planName"
              :rules="requireRule"
              :label="$t('Insurance Plan Name')"
              outlined
              required
            ></v-text-field>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="form.groupName"
              :label="$t('Insurance Group Name')"
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="form.insuranceID"
              :label="$t('Insurance ID')"
              :rules="requireRule"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            class='pa-5 pb-0'
            cols="12"
          >
            <v-text-field
              v-model="form.insuranceGroup"
              :label="$t('Insurance Group Number')"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-title>{{$t('Upload a copy of your insurance card (front and back side)')}}</v-card-title>
        <v-file-input
          @change='onFileChange'
          v-model='uploadfiles'
          chips
          multiple
          :label="$t('Upload Files here')"
        ></v-file-input>
        <p class='mt-12 font-weight-black'>{{$t('I hereby authorize Genetic Support Foundation and the providers and staff associated with Genetic Support Foundation to release medical and other information acquired in the course of my examination and/or treatment to the necessary insurance companies, third party payers, and/or other physicians or healthcare entities required to participate in my care. I hereby authorize assignment of financial benefits directly to Genetic Support Foundation and any associated healthcare entities for services rendered as allowable under standard third party contracts. I understand that I am financially responsible for charges not covered by this assignment.')}} </p>
      </div>

    </v-card-text>

    <v-card-text v-if='form.paymentMethod === "cc"'>
      <p class='subtitle-1 font-weight-bold'>{{$t('I do not wish to have information released to my insurance and prefer to pay upfront for the visit. The cost of the visit if paid prior to, or at the time of the genetic counseling visit is $200 for a new patient consult. I understand I may submit claims to insurance at my discretion.')}} </p>

      <p class='subtitle-1 font-weight-bold'>

        <a @click='$router.push("/application")'>{{$t('Genetic Support Foundation also has a financial assistance program for individuals who qualify based on the Federal Poverty Guidelines.')}}</a><a
          href='https://geneticsupportfoundation.org/telehealth-genetic-counseling'
          target='blank'
        >Here</a>

      </p>

    </v-card-text>

    <v-card-text v-if='form.paymentMethod === "fa"'>
      <FinancialAssistanceV2 />

    </v-card-text>
    <div v-if='form.paymentMethod !== "fa"'>
      <v-btn
        color="primary"
        @click="currentStep = 5"
      >
        {{$t('Continue')}}
      </v-btn>
      <v-btn
        @click="currentStep = 3"
        text
      >
        {{$t('Back')}}
      </v-btn>

    </div>

  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { insuranceType } from "../data/dataSource";
import FinancialAssistanceV2 from "./fa2.vue";
export default {
  components: {
    FinancialAssistanceV2,
  },
  mounted() {
    this.form.filesBase64 = [];
  },
  watch: {
    language(val) {
      this.insuranceDropdown = insuranceType(val);
    },
  },
  computed: {
    ...mapFields([
      "form",
      "language",
      "currentStep",
      "selectedStateID",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
      "doctorReferece",
      "userProfile",
    ]),
  },
  data() {
    return {
      requireRule: [(v) => !!v || "This field is required"],
      paymentDialog: false,
      insuraceDialog: false,
      method: null,
      insuranceDropdown: insuranceType(this.language),
      uploadfiles: [],
      filesBase64: [],
    };
  },
  methods: {
    getBase64(file, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        callback(reader.result.replace("data:", "").replace(/^.+,/, ""))
      );
      reader.readAsDataURL(file);
    },
    onFileChange() {
      this.uploadfiles.forEach((file) => {
        //convert to base64
        this.getBase64(file, (base64) => {
          this.form.filesBase64.push({
            fileName: file.name,
            fileType: file.type,
            baseString: base64,
          });
        });
      });
    },
    stateCheck(val) {
      if (this.form.state !== "WA") {
        switch (val) {
          case "Medicare":
          case "Tricare":
          case "Medicaid":
            this.dialog = true;

            break;
        }
      }
    },
    paymentDetailTitle() {
      let title;
      switch (this.form.paymentMethod) {
        case "insurance":
          title = this.$t("For Billing Insurance");
          break;
        case "fa":
          title = this.$t("For Financial Assistance");
          break;
        case "cc":
          title = this.$t("Paying with my credit card");
          break;
        default:
          title = "";
          break;
      }
      return title;
    },
    billing() {
      if (this.form.paymentMethod === "insurance") {
        this.$emit("insurance");
      }
      this.paymentDialog = false;
    },
    financialAssistance() {
      this.form.paymentMethod = "fa";
    },
    creditcard() {
      this.form.paymentMethod = "cc";
      this.paymentDialog = true;
    },
    insurance() {
      this.form.paymentMethod = "insurance";
      this.paymentDialog = true;
    },
  },
};
</script>